module.exports = __webpack_public_path__ + "img/roy.5cdf41a9.jpg";